<template>
  <StepLayout
    :back="back"
    :save="save"
    :next="next"
    :isEditRoute="true"
    help-link="https://signable.help/signing-sequences-explained/"
    buttonDataEc="envelopes_signing_sequence_page"
  >
    <template v-slot:title>
      {{ $t('ui.envelopes.create.steps.signingSequence.title') }}
    </template>

    <SigningSequenceSelector
      id="envelopes"
      ec="envelopes"
      :showTitle="false"
      :current-selection="sequence"
      @selectionUpdated="setSequence"
    >
      <template v-slot:parallelLabel="{ forId }">
        <SequenceLabel
          :label="$t('signingSequence.ui.labels.parallel')"
          :for="forId"
        >
          {{ $t('ui.envelopes.create.steps.signingSequence.descriptions.parallel') }}
        </SequenceLabel>
      </template>
      <template v-slot:sequentialLabel="{ forId }">
        <SequenceLabel
          :label="$t('signingSequence.ui.labels.sequential')"
          :for="forId"
        >
          {{ $t('ui.envelopes.create.steps.signingSequence.descriptions.sequential') }}
        </SequenceLabel>
      </template>
    </SigningSequenceSelector>
  </StepLayout>
</template>

<script setup>
// @ts-check
import { computed, ref } from 'vue';
import { useRoute } from 'vue-router/composables';

import {
  useEnvelope,
  useEnvelopesStepsNavigation,
} from '@/composables/envelopes';

import StepLayout from '@/components/layouts/StepLayout';
import SequenceLabel from '@/components/ui/signingSequence/labels/SequenceLabel.vue';
import SigningSequenceSelector from '@/components/ui/signingSequence/SigningSequenceSelector.vue';

const route = useRoute();

const { envelope } = useEnvelope(route.params.fingerprint);

// local state
const sequence = ref(envelope.value.is_parallel_signing_enabled ? 'parallel' : 'sequential');
function setSequence(newSequence) {
  sequence.value = newSequence;
}

const updateValue = computed(() => ({
  parallel_signing: sequence.value === 'parallel',
}));

// action param is temporary, will be replaced when tanstack query is implemented
const { back, save, next } = useEnvelopesStepsNavigation(
  'envelopes/updateEnvelopes',
  updateValue,
);
</script>
